import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { DynFormsService } from '../../dyn-forms/logic/dyn-forms.service';
import { ErrorService } from '../../error/error.service';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController } from '@ionic/angular';
import { IMSAction } from 'src/app/_model/menu';
import { PopoverJobSectionInstanceDynFormComponent } from 'src/app/_components/popover-jobsection-instance-dyn-form/popover-jobsection-instance-dyn-form.component';

@Injectable({
  providedIn: 'root',
})
export class PopoverJobSectionInstanceDynFormActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'popoverjobsectioninstancedynform';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private dynFormsService: DynFormsService,
    private errorService: ErrorService,
    private popoverController: PopoverController
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.logger.log(
      this.constructor.name,
      'Popover JobSection Instance Dyn Form with params',
      params
    );
    let defaultClickAction: IMSAction = JSON.parse(
      params['defaultClickAction']
    );

    if (defaultClickAction && defaultClickAction.type === 'form') {
      const dynForm = this.dynFormsService.getDynFormById({
        imsId: +defaultClickAction.target,
        secondaryId: undefined,
        objRef: 'ims/DynForm',
      });

      if (dynForm !== undefined) {
        const event = params['event'];

        this.logger.log(
          this.constructor.name,
          'Generate Popover for dyn form',
          dynForm.name,
          'at ui event',
          event
        );

        try {
          const popover = await this.popoverController.create({
            component: PopoverJobSectionInstanceDynFormComponent,
            componentProps: {
              params: params,
              dynForm: dynForm,
            },
            event: event,
            translucent: true,
          });
          await popover.present();
          return
        } catch(error) {
          this.logger.error(this.constructor.name, "Error showing popover", error?.message);
        }
      } else {
        this.logger.error(
          this.constructor.name,
          'dyn form cannot be found',
          dynForm
        );
        let message = this.translate.instant(
          'ACTION-HANDLER.POPOVER-MULTIINSTANCE-DYNFORM.NOT-MULTIINSTANCE.MESSAGE'
        );
        this.errorService.showErrorAlert(message, undefined);
      }
    } else {
      this.logger.error(
        this.constructor.name,
        'cannot initiate a popover without a dynformid'
      );
      let message = this.translate.instant(
        'ACTION-HANDLER.POPOVER-MULTIINSTANCE-DYNFORM.MISSING-ID.MESSAGE'
      );
      this.errorService.showErrorAlert(message, undefined);
    }
  }

  // Private Functions
}
